import React from 'react';
import {
    Container, Typography, Box, Paper, Divider,
    Select, MenuItem, FormControl, InputLabel,
    TextField, Button, Stack, Grid, Switch,
    FormControlLabel, TextareaAutosize
} from '@mui/material';


import useConfigForm from '../../../../../hooks/useConfigForm';
import useSendConfig from '../../../../../hooks/useSendConfig';
import { useAppStore } from '../../../../../store/appStore.tsx';
import { useValue } from '../../../../../context/ContextProvider';



const TIPO_MOD_CELULAR = [
    { value: 0, label: 'Sin Módulo Celular' },
    { value: 1, label: 'SIM800L' },
    { value: 2, label: 'A7670SA' }
];

export const generarEstadoInicialSelf = (device) => {
    return {
        deviceId: device.devId,             // Dispositivo tipo Alarma por defecto, sin número serial 
        numSerial: 0,                       // Sin número serial
        numSerial: device.devId & 0xFFFF,   // Sólo los últimos 4 dígitos hex
        celModule: 0,                       // Sin módulo celular
        celPowLogic: 0,                     // Lógica inversa para encender el módulo celular
    };
};

function ConfiguracionSelfForm({
    config,
    setConfig,
    state,
    setState,
    originalConfigRef
}) {

    const { currentUser, device, startLoading, endLoading } = useAppStore();
    const { dispatch } = useValue();

    const {
        jsonOutput,
        formDirty,
        jsonNeedsUpdate
    } = state;

    // Hook para el envío de los datos
    const { sendConfig } = useSendConfig({
        command: "CMD_SET_CONFIG_SELF",
        config,
        setState,
        originalConfigRef,
        currentUser,
        device,
        dispatch,
        startLoading,
        endLoading,
    });

    // 🔥 Hook reutilizable
    const {
        handleGenerateJson,
        handleSend,
        handleCancel
    } = useConfigForm({
        config,
        setConfig,
        state,
        setState,
        originalConfigRef,
        onSend: sendConfig
    });

    const current = config;
    if (!current) return null;

    //console.log("Inicio Self Config 4", current);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        //console.log("Config: ", config);

        let val;

        if (type === 'checkbox') {
            val = checked ? 1 : 0;
        } else if (type === 'number') {
            // Convertimos a número. 
            // Si el usuario borra todo (value === ''), lo dejamos vacío para que no ponga un '0' forzado.
            val = value === '' ? '' : Number(value);
        } else {
            val = value;
        }

        const newConfig = { ...config, [name]: val };

        //console.log("newConfig: ", newConfig);

        setConfig(newConfig);
    };

    //console.log("Inicio Self Config 5");

    return (
        <Container maxWidth="lg" sx={{ mt: 4 }}>
            <Paper elevation={3} sx={{ p: 3 }}>
                <Typography variant="h5">
                    Configuración de Constantes del Dispositivo
                </Typography>

                <Divider sx={{ mb: 2 }} />

                <Grid container spacing={3}>

                    {/* IZQUIERDA */}
                    <Grid item xs={12} md={6}>
                        <Paper variant="outlined" sx={{ p: 2, height: '100%', position: 'relative', pt: 4 }}>

                            <Typography
                                variant="caption"
                                sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 12,
                                    transform: 'translateY(-50%)',
                                    bgcolor: 'background.paper',
                                    px: 1,
                                    color: 'primary.main',
                                    fontWeight: 'bold',
                                    fontSize: '0.8rem',
                                    textTransform: 'uppercase'
                                }}
                            >
                                Características Dispositivo
                            </Typography>

                            <Grid item xs={12}> <FormControlLabel control={<Switch name="celPowLogic" checked={!!current.celPowLogic} onChange={handleChange} disabled={current.celModule === 0} />} label="Lógica para el encendido del Módulo Celular" /> </Grid>

                            <FormControl fullWidth sx={{ mt: 2, mb: 3 }}>
                                <InputLabel>Módulo Celular</InputLabel>
                                <Select
                                    name="celModule"
                                    value={current.celModule}
                                    onChange={handleChange}
                                    label="Módulo Celular"
                                >
                                    {TIPO_MOD_CELULAR.map(t => (
                                        <MenuItem key={t.value} value={t.value}>
                                            {t.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <Grid item xs={12} marginBottom={3}>
                                <TextField fullWidth type="number" name="numSerial" label="Número Serial" value={current.numSerial} onChange={handleChange} inputProps={{ min: 0, max: 65536 }} />
                            </Grid>

                            <Grid item xs={12} marginBottom={3}>
                                <TextField fullWidth type="number" name="deviceId" label="Id del dispositivo" value={current.deviceId} onChange={handleChange} inputProps={{ min: 0, max: 4294967296 }} />
                            </Grid>

                        </Paper>
                    </Grid>

                    {/* DERECHA */}
                    <Grid
                        item
                        xs={12}
                        md={6}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2
                        }}
                    >

                        {/* JSON */}
                        <Paper
                            variant="outlined"
                            sx={{
                                p: 2,
                                flexGrow: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                position: 'relative',
                                pt: 4
                            }}
                        >
                            <Typography
                                variant="caption"
                                sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 12,
                                    transform: 'translateY(-50%)',
                                    bgcolor: 'background.paper',
                                    px: 1,
                                    color: 'primary.main',
                                    fontWeight: 'bold',
                                    fontSize: '0.8rem',
                                    textTransform: 'uppercase'
                                }}
                            >
                                JSON DE CONFIGURACIÓN
                            </Typography>


                            {jsonOutput ? (
                                <Box sx={{ flexGrow: 1, overflowY: 'auto', mb: 2 }}>
                                    <TextareaAutosize
                                        value={jsonOutput}
                                        minRows={10}
                                        maxRows={36}
                                        style={{
                                            width: '100%',
                                            border: `1px solid ${jsonNeedsUpdate ? '#ff9800' : '#ccc'}`,
                                            borderRadius: '4px',
                                            padding: '8px',
                                            fontFamily: 'monospace',
                                            resize: 'vertical',
                                            backgroundColor: jsonNeedsUpdate ? '#ffe0b2' : 'white'
                                        }}
                                        readOnly
                                    />
                                </Box>
                            ) : (
                                <Box
                                    sx={{
                                        flexGrow: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Typography color="text.secondary">
                                        Genera el JSON para previsualizarlo aquí.
                                    </Typography>
                                </Box>
                            )}


                            <Button
                                variant="contained"
                                color={jsonNeedsUpdate ? "warning" : "primary"}
                                onClick={handleGenerateJson}
                            >
                                {jsonNeedsUpdate ? "Actualizar JSON" : "Generar JSON"}
                            </Button>
                        </Paper>

                        {/* RESUMEN */}
                        <Paper variant="outlined" sx={{ p: 2, position: 'relative', pt: 4 }}>
                            <Typography variant="h6">Resumen</Typography>

                            <Typography>Id del dispositivo: {current.deviceId} (0x{current.deviceId.toString(16).toUpperCase().padStart(8, '0')})</Typography>
                            <Typography>Número serial: {current.numSerial} (0x{current.numSerial.toString(16).toUpperCase().padStart(4, '0')})</Typography>
                            <Typography>
                                Módulo Celular: {TIPO_MOD_CELULAR.find(t => t.value === current.celModule)?.label}
                            </Typography>
                            <Typography>Lógica de encendido: {current.celPowLogic === 0 ? 'Inversa' : 'Directa'}</Typography>

                            <Box mt={2}>
                                <Typography color={formDirty ? 'error' : 'success.main'}>
                                    Formulario Modificado: {formDirty ? 'Sí' : 'No'}
                                </Typography>

                                <Typography color={jsonNeedsUpdate ? 'warning.main' : 'success.main'}>
                                    JSON Actualizado: {jsonNeedsUpdate ? 'No' : 'Sí'}
                                </Typography>
                            </Box>
                        </Paper>
                    </Grid>

                    {/* RESULTADO ENVÍO */}
                    <Grid item xs={12}>
                        <Paper variant="outlined" sx={{ p: 2 }}>
                            <Typography variant="caption" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                                RESULTADO ENVÍO AL DISPOSITIVO
                            </Typography>

                            <Typography sx={{ mt: 1 }}>
                                ConfigId: {state.configId || 0}
                            </Typography>

                            <Typography sx={{ color: state.color || 'black' }}>
                                Estado: {state.estado || 'Sin cambios'}
                            </Typography>
                        </Paper>
                    </Grid>


                    {/* BOTONES */}
                    <Grid item xs={12}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                            <Stack direction="row" spacing={2}>
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    onClick={handleCancel}
                                    disabled={!formDirty}
                                >
                                    CANCELAR
                                </Button>

                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSend}
                                    disabled={jsonNeedsUpdate}
                                >
                                    ENVIAR
                                </Button>
                            </Stack>
                        </Box>
                    </Grid>

                </Grid>
            </Paper>
        </Container>
    );
}

export default ConfiguracionSelfForm;
